import {
  GET_TRANSFER_LINE_STORE_REQUEST,
  GET_TRANSFER_LINE_RESET_REQUEST,
  GET_TRANSFER_OPTION_FAILURE,
  GET_TRANSFER_OPTION_REQUEST,
  GET_TRANSFER_OPTION_SUCCESS,
  GET_TRANSFER_LINE_DETAIL_INSTRUCTION_FAILURE,
  GET_TRANSFER_LINE_DETAIL_INSTRUCTION_REQUEST,
  GET_TRANSFER_LINE_DETAIL_INSTRUCTION_SUCCESS,
  GET_TRANSFER_LINE_ORDER_SUBMIT_FAILURE,
  GET_TRANSFER_LINE_ORDER_SUBMIT_REQUEST,
  GET_TRANSFER_LINE_ORDER_SUBMIT_SUCCESS,
  TRANSFER_MOBILE_LINE_DOCUMENT_UPLOAD_FAILURE,
  TRANSFER_MOBILE_LINE_DOCUMENT_UPLOAD_REQUEST,
  TRANSFER_MOBILE_LINE_DOCUMENT_UPLOAD_SUCCESS,
  TRANSFER_MOBILE_LINE_DOCUMENT_DOWNLOAD_FAILURE,
  TRANSFER_MOBILE_LINE_DOCUMENT_DOWNLOAD_REQUEST,
  TRANSFER_MOBILE_LINE_DOCUMENT_DOWNLOAD_SUCCESS,
  TRANSFER_MOBILE_LINE_DOCUMENT_DELETE_FAILURE,
  TRANSFER_MOBILE_LINE_DOCUMENT_DELETE_REQUEST,
  TRANSFER_MOBILE_LINE_DOCUMENT_DELETE_SUCCESS,
  GET_TRANSFER_LINE_PERSONAL_PLANS_REQUEST,
  GET_TRANSFER_LINE_PERSONAL_PLANS_SUCCESS,
  GET_TRANSFER_LINE_PERSONAL_PLANS_FAILURE
} from './actionTypes';

export const getTransferOption = {
  request: () => ({ type: GET_TRANSFER_OPTION_REQUEST }),
  success: (data) => ({ type: GET_TRANSFER_OPTION_SUCCESS, data }),
  failure: (error) => ({ type: GET_TRANSFER_OPTION_FAILURE, error })
};

export const getTransferLineStore = (transferLineStoreData) => ({
  type: GET_TRANSFER_LINE_STORE_REQUEST,
  transferLineStoreData
});

export const resetTransferLineStore = () => ({
  type: GET_TRANSFER_LINE_RESET_REQUEST
});

export const getConversionOfLineDetail = {
  request: (reqData) => ({ type: GET_TRANSFER_LINE_DETAIL_INSTRUCTION_REQUEST, reqData }),
  success: (data) => ({ type: GET_TRANSFER_LINE_DETAIL_INSTRUCTION_SUCCESS, data }),
  failure: (error) => ({ type: GET_TRANSFER_LINE_DETAIL_INSTRUCTION_FAILURE, error })
};

export const uploadTransferLineDocuments = {
  request: (newFiles, documentName, callback: (uploadedDocumentsId) => void = () => null) => ({
    type: TRANSFER_MOBILE_LINE_DOCUMENT_UPLOAD_REQUEST,
    newFiles,
    documentName,
    callback
  }),
  success: () => ({ type: TRANSFER_MOBILE_LINE_DOCUMENT_UPLOAD_SUCCESS }),
  failure: (error) => ({ type: TRANSFER_MOBILE_LINE_DOCUMENT_UPLOAD_FAILURE, error })
};

export const downloadDocumentTransferLine = {
  request: (documentId, callback: React.ReactNode | null = () => null) => ({
    type: TRANSFER_MOBILE_LINE_DOCUMENT_DOWNLOAD_REQUEST,
    documentId,
    callback
  }),
  success: (data) => ({ type: TRANSFER_MOBILE_LINE_DOCUMENT_DOWNLOAD_SUCCESS, data }),
  failure: (error) => ({ type: TRANSFER_MOBILE_LINE_DOCUMENT_DOWNLOAD_FAILURE, error })
};

export const deleteDocumentTransferLine = {
  request: (deleteId, callback: () => void = () => null) => ({
    type: TRANSFER_MOBILE_LINE_DOCUMENT_DELETE_REQUEST,
    deleteId,
    callback
  }),
  success: (data) => ({ type: TRANSFER_MOBILE_LINE_DOCUMENT_DELETE_SUCCESS, data }),
  failure: () => ({ type: TRANSFER_MOBILE_LINE_DOCUMENT_DELETE_FAILURE })
};

export const getTransferLineOrder = {
  request: (reqData) => ({ type: GET_TRANSFER_LINE_ORDER_SUBMIT_REQUEST, reqData }),
  success: (data) => ({ type: GET_TRANSFER_LINE_ORDER_SUBMIT_SUCCESS, data }),
  failure: (error) => ({ type: GET_TRANSFER_LINE_ORDER_SUBMIT_FAILURE, error })
};

export const getTransferLinePersonalPlans = {
  request: () => ({ type: GET_TRANSFER_LINE_PERSONAL_PLANS_REQUEST }),
  success: (data) => ({ type: GET_TRANSFER_LINE_PERSONAL_PLANS_SUCCESS, data }),
  failure: (error) => ({ type: GET_TRANSFER_LINE_PERSONAL_PLANS_FAILURE, error })
};